module.exports = __webpack_public_path__ + "img/platform_login_logo.590e6123.svg";